import { defaultInternalLogger } from './const';
import { createInternalLogger } from './createInternalLogger';
export let internalLogger = defaultInternalLogger;
export function initializeInternalLogger(unpatchedConsole, config) {
    internalLogger = createInternalLogger(unpatchedConsole, config.internalLoggerLevel);
    return internalLogger;
}
